/* ProcessDemo: three-step tabs that swap the image, heading and copy. */
(function () {
  document.querySelectorAll('[data-process-demo]').forEach(function (root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-process-tab]'));
    var images = Array.prototype.slice.call(root.querySelectorAll('[data-process-image]'));
    var title = root.querySelector('[data-process-title]');
    var text = root.querySelector('[data-process-text]');
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t, j) { t.setAttribute('aria-pressed', String(i === j)); });
        images.forEach(function (img, j) { img.hidden = i !== j; });
        title.textContent = tab.getAttribute('data-title');
        text.textContent = tab.getAttribute('data-text');
      });
    });
  });
})();
